import Alpine from 'alpinejs';
import $money from './modules/AlpineMoney.js';
import scrollTo from 'alpinejs-scroll-to'
Alpine.plugin(scrollTo)
import focus from '@alpinejs/focus';
Alpine.plugin(focus);
import money from 'alpinejs-money';
import { Breakpoints } from "../breakpoints.js";
import { slideDown, slideToggle, slideUp, slideToggleDefaults, SlideToggleContainer } from './snippets/slide-toggle-container.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FloatingIcon } from './modules/FloatingIcon.js';
import { register } from 'swiper/element/bundle';
import Cart from './modules/Cart.js';
import staggerWords from './modules/motion/staggerWords.js';
import fadeUp from './modules/motion/fadeUp.js';
import popInLoad from './modules/motion/popInLoad.js';
import popInView from './modules/motion/popInView.js';
import slideFromLeft from './modules/motion/slideFromLeft.js';
import slideFromRight from './modules/motion/slideFromRight.js';
import parallax from './modules/motion/parallax.js';
import parallaxDrift from './modules/motion/parallaxDrift.js';
import timelineScroll from './modules/motion/timelineScroll.js';
import marquee from './modules/motion/marquee.js';
import draggableSticker from './modules/draggableSticker.js';
import overflowScroll from './modules/overflowScroll.js';
import videoControls from './modules/videoControls.js';
import videoWrapper from './modules/videoWrapper.js';
import ProductCard from './modules/ProductCard.js';
import accordionPanel from './modules/accordionPanel.js';
import productSwitcher from './modules/productSwitcher.js';
import pencilBar from './modules/pencilBar.js';
import shyHeader from './modules/shyHeader.js';
import InlineSvg from './modules/inlineSvg.js';
import { Modal } from './modules/Modal.js';
import { initLenis } from './modules/lenis.js';
register();
gsap.registerPlugin(ScrollTrigger);
// Expose ScrollTrigger globally so the Lenis ticker can call `window.ScrollTrigger.update()`.
window.ScrollTrigger = ScrollTrigger;

document.addEventListener('alpine:init', () => {
  Alpine.data('staggerWords', staggerWords);
  Alpine.data('fadeUp', fadeUp);
  Alpine.data('popInLoad', popInLoad);
  Alpine.data('popInView', popInView);
  Alpine.data('slideFromLeft', slideFromLeft);
  Alpine.data('slideFromRight', slideFromRight);
  Alpine.data('parallax', parallax);
  Alpine.data('parallaxDrift', parallaxDrift);
  Alpine.data('timelineScroll', timelineScroll);
  Alpine.data('marquee', marquee);
  Alpine.data('draggableSticker', draggableSticker);
  Alpine.data('overflowScroll', overflowScroll);
  Alpine.data('videoControls', videoControls);
  Alpine.data('videoWrapper', videoWrapper);
  Alpine.data('ProductCard', ProductCard);
  Alpine.data('accordionPanel', accordionPanel);
  Alpine.data('productSwitcher', productSwitcher);
  Alpine.data('pencilBar', pencilBar);
  Alpine.data('shyHeader', shyHeader);
  Alpine.bind('SlideToggleContainer', SlideToggleContainer);
});

// Hack: This next line hides alpine money.
// window.Shopify.locale = 'en-CA';
window.Alpine = Alpine;
window.gsap = gsap;

// Lenis smooth scroll — initialize after gsap is on window so the module
// can drive Lenis from gsap.ticker for ScrollTrigger sync.
initLenis();

Alpine.store('cart', Cart());
Alpine.store('modal', Modal);
Alpine.store('badges', []);
Alpine.plugin(money);
$money();

window.setSectionTabindex = (el, to = "-1") => {
  [...(el instanceof NodeList
    ? el
    : el.querySelectorAll('a, input, button'))
    ].forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};

window.slideToggle = (el, opts = {}) => {
  slideToggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  slideUp(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  slideDown(el, { ...slideToggleDefaults, ...opts });
};

window.Breakpoints = Breakpoints;

window.Alpine = Alpine;

if (!customElements.get('floating-icon')) {
  customElements.define('floating-icon', FloatingIcon);
}

if (!customElements.get('inline-svg')) {
  customElements.define('inline-svg', InlineSvg);
}

